/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithAdminHold
 */
export interface WithAdminHoldOptional {
  /**
   *
   * @type {boolean}
   * @memberof WithAdminHold
   */
  adminHold?: boolean;
}

export interface WithAdminHold extends WithAdminHoldOptional {
  /**
   *
   * @type {boolean}
   * @memberof WithAdminHold
   */
  adminHold?: boolean;
}

export interface WithAdminHoldTrackedI {
  /**
   *
   * @type {boolean}
   * @memberof WithAdminHold
   */
  adminHold?: boolean;
  adminHoldIsSet: boolean;
}

transformDatesMap.set("WithAdminHold", function (model: WithAdminHold) {});

export type WithAdminHoldMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  adminHold: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var WithAdminHoldMeta: WithAdminHoldMetaI = {} as WithAdminHoldMetaI;
WithAdminHoldMeta = typeMeta("WithAdminHold", {
  adminHold: propertyMeta(
    "adminHold",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = WithAdminHoldMeta;

registerMeta(() => {});

export class WithAdminHoldTracked implements WithAdminHoldTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  adminHold__I?: boolean = undefined;
  adminHoldIsSet: boolean = false;
  set adminHold(v: undefined | boolean) {
    if (v !== undefined) {
      this.adminHold__I = v;
      this.adminHoldIsSet = true;
    } else {
      this.adminHold__I = v || undefined;
      this.adminHoldIsSet = false;
    }
    this.changeTracker = true;
  }
  get adminHold() {
    return this.adminHold__I;
  }
  constructor(config?: WithAdminHoldOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithAdminHoldOptional,
    options?: AssignOptions,
  ): WithAdminHoldTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.adminHold && this.adminHoldApplyFilter(optionsRequired.filter)) {
      this.adminHold = config.adminHold;
      if (optionsRequired.unassign) this.adminHoldIsSet = false;
      else this.adminHoldIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithAdminHoldTrackedI {
    const cloned = {} as WithAdminHoldTrackedI;
    if (
      this.adminHoldIsSetDeep() &&
      this.adminHoldApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.adminHoldIsSet = true;
      cloned.adminHold = this.adminHold;
    } else {
      //cloned.adminHoldIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithAdminHoldTrackedI {
    if (!this.adminHoldApplyFilter(filter)) this.adminHoldIsSet = false;

    return this;
  }
  adminHoldApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithAdminHoldMeta.adminHold,
      WithAdminHoldMeta,
      this.adminHold,
      this,
    );
  }
  adminHoldIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.adminHoldIsSet && this.adminHoldApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.adminHoldIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
